import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as glAccounts from '../../../../gl-accounts'
import * as entry from '../entry'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: entry.RESOURCE.payload.dimension.partialId,
      partialId: entry.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'TODO',
    isOptional: false,
    name: 'Account',
    partialId: PartialId.Standard.create('acct'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        glAccounts.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
